import { API } from "../../api/constants"
import { authenticatedAxiosInstance } from "../../auth/AuthenticatedAxios"

export const resendMail = (data: { path: string; body?: { mailReceivers?: string[]; mailReportId?: string } }) => {
    if (data.path.trim() === "") {
        if (!data.body?.mailReportId || data.body.mailReportId.trim() === "") {
            throw new Error("Mail Report ID is required")
        }
        return authenticatedAxiosInstance.post(API + "/manual/mail-report/resend", data.body).then((res) => res.data)
    } else {
        return authenticatedAxiosInstance.post(API + data.path, data.body).then((res) => res.data)
    }
}
